<template>
  <div
    :style="scaleStyle"
    ref="previewMain"
    :class="{ 'is-sample': isSample, 'is-preview': !isSample }"
  >
    <EnglishResumePreviewDoc
      :format-data="formatData"
      :basic-data="basicData"
      :jobs-page1="jobsPage1"
      :full-name="fullName"
      :full-address="fullAddress"
      :full-phone="fullPhone"
      :formated-create-date="formatedCreateDate"
      :highlight-message="highlightMessage"
      :current-card-id="currentCardId"
      :id-prefix="idPrefix"
      :is-sample="isSample"
      :card-changed="cardChanged"
      @go-card-to="goCardTo"
    />
    <EnglishResumePreviewDocPage2
      v-if="isTwoPage"
      :jobs-page2="jobsPage2"
      :full-name="fullName"
      :highlight-message="highlightMessage"
      :current-card-id="currentCardId"
      :id-prefix="idPrefix"
      :is-sample="isSample"
      :card-changed="cardChanged"
      @go-card-to="goCardTo"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useHostServices } from '@/composables/format-edit/useHostServices'
import { useFormatPreview } from '@/composables/format-edit/useFormatPreview'
import { splitJobHistories } from '@/utils/format-edit/englishResumePreview'
import EnglishResumePreviewDoc from '@/components/format-edit/english-resume/EnglishResumePreviewDoc.vue'
import EnglishResumePreviewDocPage2 from '@/components/format-edit/english-resume/EnglishResumePreviewDocPage2.vue'

type FormatPreviewSfcProps = {
  formatData: Record<string, any>
  basicData: Record<string, any>
  previewScale?: number
  currentCardId?: string | string[]
  idPrefix?: string
  isSample?: boolean
}

const props = withDefaults(defineProps<FormatPreviewSfcProps>(), {
  previewScale: 1,
  currentCardId: '',
  idPrefix: '',
  isSample: false
})

const { formLib } = useHostServices()
const { cardChanged, scaleStyle, highlightMessage, goCardTo } =
  useFormatPreview(props)

const jobPages = computed(() =>
  splitJobHistories(props.formatData?.jobHistories)
)
const isTwoPage = computed(() => jobPages.value.isTwoPage)
const jobsPage1 = computed(() => jobPages.value.jobsPage1)
const jobsPage2 = computed(() => jobPages.value.jobsPage2)

const fullName = computed(() => {
  const first = props.basicData?.firstName || ''
  const last = props.basicData?.lastName || ''
  return `${first} ${last}`.trim()
})

const fullAddress = computed(() => props.formatData?.address || '')

const fullPhone = computed(() => {
  const t1 = props.basicData?.tel1 || ''
  const t2 = props.basicData?.tel2 || ''
  const t3 = props.basicData?.tel3 || ''
  if (!t1 && !t2 && !t3) return ''
  return [t1, t2, t3].filter(Boolean).join('-')
})

const formatedCreateDate = computed(() => {
  if (!props.formatData?.createDate) return ''
  return formLib.dateFormat(props.formatData.createDate, 'm/yyyy')
})

function checkValid() {}

defineExpose({ checkValid })
</script>
